import moment from 'moment';
import { makeSelect, makeInputText } from './data-constr.js';

export const storiesPrintPool = makeSelect('#storiesPrintPool');
window.storiesPrintPool = storiesPrintPool;
export const vipToken = makeInputText('#vip-token');
window.vipToken = vipToken;

export function formatRange([startDate, endDate], defaultFormatTemplate = 'YYYY-MM-DD HH:mm') {
  return [startDate.format(defaultFormatTemplate), endDate.format(defaultFormatTemplate)];
}

export function toUTCRange([startDate, endDate]) {
  return [moment.utc(startDate), moment.utc(endDate)];
}
